import { render, staticRenderFns } from "./OrderLedgerExplanationModal.vue?vue&type=template&id=77de59d3&scoped=true&"
import script from "./OrderLedgerExplanationModal.vue?vue&type=script&lang=js&"
export * from "./OrderLedgerExplanationModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderLedgerExplanationModal.vue?vue&type=style&index=0&id=77de59d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de59d3",
  null
  
)

export default component.exports